import { render } from "./CookiesButton.vue?vue&type=template&id=4527ce52&scoped=true&ts=true"
import script from "./CookiesButton.vue?vue&type=script&lang=ts"
export * from "./CookiesButton.vue?vue&type=script&lang=ts"

import "./CookiesButton.vue?vue&type=style&index=0&id=4527ce52&scoped=true&lang=css"

import exportComponent from "C:\\Users\\khale\\Cookies BIS\\Core-Abudari\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4527ce52"]])

export default __exports__